<div class="twc-row">
    <div class="twc-col-12 input-file">
        <cw-input-file (added)="onSetImage($event)" [hideListFiles]="true"></cw-input-file>
    </div>
</div>
<div class="twc-row twc-mt-4">
    <div class="twc-col-12 twc-mt-2">
        <div class="position-relative delete-button" *ngIf="isImageSetted">
            <button class="twc-button twc-button-floating twc-button-s twc-mb-3 delete-button"
                (click)="onRemoveImage()">
                <twc-icon [shape]="'delete'" class="topcon-blue"></twc-icon>
            </button>
        </div>
        <img class="preview" [src]="srcImg" alt="{{'UPLOAD.UPLOADED_IMAGE_ALT' | translate}}"/>
    </div>
</div>